import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Logo, LogoMark } from "../Logo";

const POINTS = [
  "Describe systems in plain English",
  "AI-generated connectors, sandbox-tested",
  "Federated queries with citations",
];

export function AuthShell({
  children,
  title,
  subtitle,
}: {
  children: ReactNode;
  title: string;
  subtitle: string;
}) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden flex-col justify-between overflow-hidden bg-brand-gradient p-12 text-white lg:flex">
        <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 animate-blob rounded-full bg-white/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-28 -left-16 h-80 w-80 animate-blob rounded-full bg-accent-400/20 blur-3xl [animation-delay:3s]" />
        <Link to="/" className="relative flex items-center gap-2.5">
          <LogoMark size={34} className="ring-2 ring-white/20" />
          <span className="text-lg font-extrabold tracking-[0.14em]">
            SHINEY<span className="text-sky-300"> WISE</span>
          </span>
        </Link>
        <div className="relative">
          <h2 className="max-w-sm text-3xl font-bold leading-tight">
            The AI integration platform for the whole enterprise.
          </h2>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-3 text-white/90">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white/15">
                  <Check className="h-3.5 w-3.5" />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </div>
        <p className="relative text-sm text-white/60">Wise 2.0 — by Shineywise</p>
      </div>

      {/* Form side */}
      <div className="flex flex-col justify-center px-6 py-12 sm:px-12">
        <div className="mx-auto w-full max-w-sm">
          <Link to="/" className="inline-flex lg:hidden">
            <Logo />
          </Link>
          <h1 className="mt-8 text-2xl font-bold tracking-tight text-slate-900 lg:mt-0">{title}</h1>
          <p className="mt-1.5 text-sm text-slate-500">{subtitle}</p>
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
